import { FormControl } from '@angular/forms';
import { ProjectService } from './project.service';
import { Component, Injector, ViewChild, OnInit, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  selector: 'my-projects',
  templateUrl: './my-projects.component.html',
  styleUrls: ['./my-projects.component.less'],
})
export class MyProjectsComponent extends AppComponentBase implements OnInit {
  projects = [];
  projectId;
  projectName: string =''
  @Input() isDropup = false;
  @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean btn-lg mr-1';

  constructor(injector: Injector,
    private _projectService: ProjectService) {
    super(injector);
  }

  ngOnInit(): void {
    (async ()=> {
      const projects = await this._projectService.getMyProjects();
      if(projects && projects.items){
        var activeProjects = [];
        projects.items.map((pro) => {
            if (pro['isVisible'] == true) {
                activeProjects.push(pro);
            }
          })
        this.projects = activeProjects;
        this.projectId = await this._projectService.getCurrentOrDefaultProjectId();
        if(this.projectId){
          this.projectName = this.projects.find(x=>x.id===this.projectId)?.name
        }
      }
    })();

  }
  async changeProject(project){
    await this._projectService.setCurrentProjectAsync(project);
    (window as any).location.reload();
  }

  isMobileDevice(){
    return KTUtil.isMobileDevice();
  }
}
